import { DocumentType } from '@/lib/patientDocumentsApi';

// One consistent "soft" accent formula per document type — matches this
// app's established badge-medical-*/badge-status-* pattern (color/10 bg,
// color/20 border, color text) rather than inventing a new visual language.
export const TYPE_META: Record<DocumentType, { label: string; token: string }> = {
  external_prescription: { label: 'External Rx', token: 'info' },
  clinical_photo: { label: 'Clinical Photo', token: 'medical-diagnosis' },
  identity_document: { label: 'ID / Insurance', token: 'warning' },
  other: { label: 'Other', token: 'muted-foreground' },
};

export default function TypeBadge({ type }: { type: DocumentType }) {
  const meta = TYPE_META[type];
  return (
    <span
      className="inline-flex items-center rounded-full px-1.5 py-0.5 text-[10px] font-medium leading-none whitespace-nowrap"
      style={{
        backgroundColor: `hsl(var(--${meta.token}) / 0.1)`,
        color: `hsl(var(--${meta.token}))`,
        border: `1px solid hsl(var(--${meta.token}) / 0.25)`,
      }}
    >
      {meta.label}
    </span>
  );
}
